import { useMemo } from 'react';

import { api } from '@/api';

import { useStudyGuard } from '../guard';

export function useAppsStudies() {
  const {
    radiologistScan: { patientID },
  } = useStudyGuard();

  const { data } = api.apps.study.query.useGetStudies(
    { payload: { params: { status: 'scanned', users: [patientID] } } },
    { enabled: false },
  );

  const value = useMemo(() => ({ studies: data?.studies ?? [] }), [data]);

  return value;
}
